/* 夏侯淵傳・第 2 章：東海・降十餘屯（206 年）
 * 東海郡的山地：西南是夏侯淵進來的地方；山間散著四座屯（遊戲把十餘屯縮成四座），東北是昌豨的大屯，東南是于禁的營。 */
export const START = [900, 4300], TUNS = [[2300, 3300], [2100, 1500], [4200, 2500], [5500, 4000]], MAIN = [6900, 1400], YUJIN = [7400, 3500];
export default {
  id: 'xiahouyuan_donghai', name: '東海', W: 8400, H: 5200, seed: 206,
  bases: [START, MAIN],
  roads: [
    { pts: [START, TUNS[0], TUNS[2], [5600, 2100], MAIN], w: 120 },
    { pts: [TUNS[0], TUNS[1], [3300, 1700], TUNS[2]], w: 100 },
    { pts: [TUNS[2], TUNS[3], [6600, 3800], YUJIN, [7300, 2400], MAIN], w: 100 },
  ],
  rocks: [[3300, 3600, 420, 220], [1100, 2400, 380, 200], [3300, 700, 500, 220], [5200, 1100, 420, 200], [6400, 2700, 380, 180], [4100, 4500, 420, 180], [7600, 500, 400, 180]],
  woods: 0.55,
  sight: 0.8,
  clearings: [[START[0], START[1], 400], ...TUNS.map(([x, y]) => [x, y, 480]), [MAIN[0], MAIN[1], 620], [YUJIN[0], YUJIN[1], 380]],
  tents: [...TUNS.map(([x, y]) => ({ x, y, n: 4, r: 300, col: '#6a5a3a', flag: '昌' })), { x: MAIN[0], y: MAIN[1], n: 7, r: 420, chief: true, col: '#6a5a3a', flag: '豨' }, { x: YUJIN[0], y: YUJIN[1], n: 4, r: 260, col: '#3b5a99', flag: '于' }],
  grass: [[3200, 2900, 200, 90], [4800, 3300, 200, 90]],
};
